import { __module as stripComments } from "../../../../../../../_virtual/stripComments.js";
var hasRequiredStripComments;
function requireStripComments() {
  if (hasRequiredStripComments) return stripComments.exports;
  hasRequiredStripComments = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = stripComments2;
    function stripComments2(str) {
      var s = "";
      var commentStart = str.indexOf("/*");
      var lastEnd = 0;
      while (commentStart >= 0) {
        s = s + str.slice(lastEnd, commentStart);
        var commentEnd = str.indexOf("*/", commentStart + 2);
        if (commentEnd < 0) {
          return s;
        }
        lastEnd = commentEnd + 2;
        commentStart = str.indexOf("/*", lastEnd);
      }
      s = s + str.slice(lastEnd);
      return s;
    }
    module.exports = exports$1.default;
  })(stripComments, stripComments.exports);
  return stripComments.exports;
}
export {
  requireStripComments as __require
};
//# sourceMappingURL=stripComments.js.map
